import { Box } from "@mui/material";
import React from "react";
import type { FieldConfiguration } from "../../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type { DimensionField, ReportField } from "../../../../../../../../../api/types/svTypes.ts";
import { AreaItemType, ItemDataType } from "../../../../../../../../../api/types/svTypes.ts";
import { isDimension } from "../../../../../utilities/fieldsHelper.ts";
import DisplayFieldsComponent from "../../../common/fields/format/DisplayFieldsComponent.tsx";
import ShowLogoIconComponent from "../../../common/fields/format/ShowLogoIconComponent.tsx";
import TextField from "../../../common/fields/format/TextField.tsx";

const getTextFields = (fields: ReportField[]): DimensionField[] => {
  return fields.filter(isDimension).filter((v) => v.meta.type === ItemDataType.General);
};

interface Props {
  fields: ReportField[];
  onUpdateConfig: (field: DimensionField, changes: Partial<FieldConfiguration>) => void;
  readonlyMode: boolean;
}

export default function TextFieldContainer({ fields, onUpdateConfig, readonlyMode }: Props) {
  const textFields = React.useMemo(() => getTextFields(fields), [fields]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: ".5rem" }}>
      {textFields.map((field) => (
        <TextField key={field.meta.name} field={field}>
          {field.areaItemType === AreaItemType.ROWS && (
            <ShowLogoIconComponent field={field} onUpdateConfig={onUpdateConfig} readonlyMode={readonlyMode} />
          )}
          <DisplayFieldsComponent field={field} onUpdateConfig={onUpdateConfig} readonlyMode={readonlyMode} />
        </TextField>
      ))}
    </Box>
  );
}
